import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../controls/modal/Modal";
import CustomInput from "../controls/input/customInput/CustomInput";
import Phone from "../controls/input/phoneInput/PhoneInput";
import MinimalistToggle from "../controls/toggle/MinimalistToggle";
import { isValidEmail } from "../../utils/formValidation";
import contactservice from "../../store/services/contact.service";
import { generalActions } from "../../store/actions";

// contact: null for create, an existing ContactContextDto for edit (must be isDirect)
const ContactFormModal = ({ parentType, parentId, contact, handleCancel, handleSaved }) => {
  const dispatch = useDispatch();
  const isEdit = !!contact;
  const [form, setForm] = useState({
    name: contact?.name || "",
    email: contact?.email || "",
    phone: contact?.phone || "",
    notes: contact?.notes || "",
    isShared: contact?.isShared || false,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const setField = (field) => (value) => setForm((prev) => ({ ...prev, [field]: value }));

  const validate = () => {
    const nextErrors = {};
    if (!form.name?.trim() && !form.email?.trim() && !form.phone?.trim()) {
      nextErrors.name = " ";
      nextErrors.email = " ";
      nextErrors.phone = " ";
    }
    if (form.email?.trim() && !isValidEmail(form.email)) {
      nextErrors.email = "Invalid email";
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    setIsLoading(true);
    const request = isEdit
      ? contactservice.updateContact(parentType, parentId, contact.id, form)
      : contactservice.createContact(parentType, parentId, form);

    request
      .then(() => {
        dispatch(
          generalActions.showToast({
            title: isEdit ? "Contact updated" : "Contact created",
            type: "success",
          })
        );
        handleSaved();
      })
      .catch(() =>
        dispatch(
          generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" })
        )
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <Modal
      title={isEdit ? "Edit Contact" : "Add Contact"}
      handleCancel={handleCancel}
      handleSave={handleSave}
      saveBtnLabel={isEdit ? "Save" : "Create"}
      cancelBtnLabel="Cancel"
      isLoading={isLoading}
      size="small"
      body={
        <div className="row">
          <div className="col-12 mb-3">
            <CustomInput
              label="Name"
              placeholder="Full name"
              value={form.name}
              handleChange={setField("name")}
              errorMessage={errors.name}
              displayErrorMessage={false}
            />
          </div>
          <div className="col-12 mb-3">
            <CustomInput
              label="Email"
              placeholder="name@example.com"
              value={form.email}
              handleChange={setField("email")}
              errorMessage={errors.email}
            />
          </div>
          <div className="col-12 mb-3">
            <Phone label="Phone" value={form.phone} handleChange={setField("phone")} />
          </div>
          <div className="col-12 mb-3">
            <CustomInput label="Notes" placeholder="Optional" value={form.notes} handleChange={setField("notes")} />
          </div>
          <div className="col-12">
            <MinimalistToggle
              title="Shared - visible to Portfolios/Programs/Projects under this hierarchy, and vice versa"
              checked={form.isShared}
              onChange={setField("isShared")}
              titlePosition="right"
            />
          </div>
        </div>
      }
    />
  );
};

export default ContactFormModal;
